var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":function($event){return _vm.goApps()}}},on),[_c('img',{attrs:{"src":_vm.computeLogo,"height":"36"}})])]}}])},[_c('span',[_vm._v(_vm._s(_vm.L('Ver Aplicaciones')))])])}
var staticRenderFns = []

export { render, staticRenderFns }